import React from "react";
import { useLocation } from "react-router-dom";

export default function ErrorMesssage() {
  const location = useLocation();
  const message = location.state?.message || "Something went wrong!";
  
  return (
    <div style={{ display: 'flex', height: '80vh' }}>
      <h1 style={{ margin: 'auto' }}>
        { message }
      </h1>
    </div>
  );
}